import { render } from "./CometChatMessageHeader.vue?vue&type=template&id=262b86c2&scoped=true"
import script from "./CometChatMessageHeader.vue?vue&type=script&lang=js"
export * from "./CometChatMessageHeader.vue?vue&type=script&lang=js"

import "./CometChatMessageHeader.vue?vue&type=style&index=0&id=262b86c2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262b86c2"]])

export default __exports__